import React from 'react';
import Excel_Export from '../../assets/images/export-excel-24.png';

const ExportHeader = (props) => {
    const { displayName, fileName } = props;
    // You can access gridApi via props.api if needed
    const handleExport = () => {
        if (props.api) {
            props.api.exportDataAsExcel({ fileName: fileName || 'export.xlsx' });
        }
    };

    return (
        <div className="ag-header-cell-label" style={{ display: 'flex', alignItems: 'center' }}>
            <span>{displayName || ""}</span>
            <button
                className="ag-header-icon ag-export-icon"
                style={{ marginLeft: 8 }}
                onClick={handleExport}
                title="Export to Excel"
            >
                <img src={Excel_Export} alt="Export" />
            </button>
        </div>
    );
};

export default ExportHeader;